import { Star } from "lucide-react";
import { useLang } from "@/i18n";
import { Eyebrow, Reveal } from "./Reveal";

export const Testimonials = () => {
  const { t } = useLang();

  return (
    <section id="temoignages" data-testid="testimonials-section" className="bg-[#FBF8F3] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-16 text-center">
          <Eyebrow>{t.testimonials.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.15] tracking-tight text-[#0A1F18] sm:text-4xl lg:text-5xl">
            {t.testimonials.title}
          </h2>
        </Reveal>

        <div className="grid gap-px border border-[#E4DDD0] bg-[#E4DDD0] md:grid-cols-3">
          {t.testimonials.items.map((item, i) => (
            <Reveal key={item.name} delay={i * 0.1} className="h-full">
              <figure
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col justify-between bg-white p-8 transition-transform duration-500 hover:-translate-y-1 sm:p-10"
              >
                <div>
                  <div className="flex gap-1">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} className="h-3.5 w-3.5 fill-[#C87D55] text-[#C87D55]" />
                    ))}
                  </div>
                  <blockquote className="mt-6 font-serif text-xl italic leading-relaxed text-[#0A1F18]">
                    {item.quote}
                  </blockquote>
                </div>
                <figcaption className="mt-8 border-t border-[#E4DDD0] pt-5">
                  <span className="block font-display text-base font-semibold text-[#0A1F18]">
                    {item.name}
                  </span>
                  <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.18em] text-[#5C6B64]">
                    {item.role}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
